import { cycloneApiClient } from '@/shared/api/core/axios-instance';

import type {
  CreateExperimentRequest,
  ExperimentListResponse,
  ExperimentResponse,
  GetExperimentsParams,
  UpdateExperimentRequest,
} from '@/entities/experiment/domain/experimentManagementTypes';

const EXPERIMENT_BASE_URL = '/experiments';

export const experimentManagementApi = {
  getList: async (params?: GetExperimentsParams): Promise<ExperimentListResponse> => {
    const response = await cycloneApiClient.get<ExperimentListResponse>(EXPERIMENT_BASE_URL, { params });
    return response.data;
  },

  create: async (data: CreateExperimentRequest): Promise<ExperimentResponse> => {
    const response = await cycloneApiClient.post<ExperimentResponse>(EXPERIMENT_BASE_URL, data);
    return response.data;
  },

  update: async (experimentId: number, data: UpdateExperimentRequest): Promise<ExperimentResponse> => {
    const response = await cycloneApiClient.patch<ExperimentResponse>(`${EXPERIMENT_BASE_URL}/${experimentId}`, data);
    return response.data;
  },
};
